import React from 'react';
import { Button, Popup, Stack, Typography } from 'witmeg-ui-system';
import "./TimeoutPopup.scss"
const TimeoutPopup = ({ onOkConfirm }) => {

    return (
        <Popup
            className="timeout-popup"
            modalVisible={true}
            modalTitle=""
            mask={true}
            centered
            closable={false}>
            <div className='modal-header-text'>Your session has timed out.</div>
            <div className='modal-sub-text'>To continue ordering, please scan the QR code again to refresh your session and begin a new order.</div>
            < div className='btn-container' onClick={onOkConfirm}>OK</div>
        </Popup>
    );
}

export default TimeoutPopup;